// store/modules/documentModels/reducer.js
const initialState = {
  models: [],
};

export default function documentModelsReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_DOCUMENT_MODELS':
      return {
        ...state,
        models: action.payload,
      };
    default:
      return state;
  }
}
